import React, { useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function OrderDetailInfoTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    {props.rows.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {t(row.name)}
                            </TableCell>
                            <TableCell className={classes.infoCell}>{row.info}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const useStyles = makeStyles({

    nameCell: {
        padding: "3px !important",
        border: "none !important",
        fontSize: "14px !important",
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'bold !important',
        color: "#020100 !important",
        width: '160px',
    },
    infoCell: {
        padding: "3px !important",
        border: "none !important",
        fontSize: "14px !important",
        fontFamily: "Lato, sans-serif !important ",
        fontWeight: 'medium !important',
        color: "#020100 !important",

    },
    paper: {
        boxShadow: 'none !important'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4 !important",
        },
    },
});